import React from "react";

export default function NoteIcon({ width = 16, color = "#14B8A6" }) {
  return (
    <svg
      width={width}
      height={width}
      viewBox={`0 0 ${width} ${width}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_73_1201)">
        <path
          d="M8.9335 1.33332H4.00016C3.64654 1.33332 3.3074 1.4738 3.05735 1.72384C2.80731 1.97389 2.66683 2.31303 2.66683 2.66665V13.3333C2.66683 13.6869 2.80731 14.0261 3.05735 14.2761C3.3074 14.5262 3.64654 14.6667 4.00016 14.6667H12.0002C12.3538 14.6667 12.6929 14.5262 12.943 14.2761C13.193 14.0261 13.3335 13.6869 13.3335 13.3333V8.39999M1.3335 3.99999H4.00016M1.3335 6.66665H4.00016M1.3335 9.33332H4.00016M1.3335 12H4.00016M14.2522 3.75065C14.5177 3.48508 14.6669 3.12489 14.6669 2.74932C14.6669 2.37375 14.5177 2.01356 14.2522 1.74799C13.9866 1.48242 13.6264 1.33322 13.2508 1.33322C12.8753 1.33322 12.5151 1.48242 12.2495 1.74799L8.9095 5.08932C8.75099 5.24774 8.63498 5.44354 8.57216 5.65865L8.01416 7.57199C7.99743 7.62935 7.99643 7.69016 8.01126 7.74805C8.02609 7.80593 8.05621 7.85877 8.09846 7.90102C8.14071 7.94328 8.19355 7.9734 8.25144 7.98823C8.30932 8.00306 8.37013 8.00205 8.4275 7.98532L10.3408 7.42732C10.5559 7.36451 10.7517 7.24849 10.9102 7.08999L14.2522 3.75065Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_73_1201">
          <rect width={width} height={width} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
